export enum SedsLoadersCoreTypeOptions {
  LOGO = 'logo',
  PROGRESS_BAR = 'progress_bar',
  PROGRESS_SPINNER = 'progress_spinner',
}
